export const env: string = process.env.REACT_APP_ENV || 'prod';

const urls: any = {
	local: {
		baseUrl: 'http://localhost:3003',
		fileSystemUrl: 'https://videos.xp.alkalmaup.com',
	},
	prod: {
		fileSystemUrl: 'https://videos.xp.alkalmaup.com',
		baseUrl: 'https://api.xp.alkalmaup.com',
	},
	dev: {
		baseUrl: 'https://api.xp.alkalmaup.com',
		fileSystemUrl: 'https://videos.xp.alkalmaup.com',
	},
	staging: {
		baseUrl: 'https://api.xp.alkalmaup.com',
		fileSystemUrl: 'https://videos.xp.alkalmaup.com',
	},
};

export const baseUrl = urls[env].baseUrl;
// export const baseUrl = 'http://localhost:3003';
export const fileSystemUrl = urls[env].fileSystemUrl;
